<div class="coming-soon-container">
  <app-header></app-header>

  <main class="coming-soon-content">
    <section class="hero-section">
      <div class="hero-background">
        <div class="floating-elements">
          <div class="floating-element element-1"></div>
          <div class="floating-element element-2"></div>
          <div class="floating-element element-3"></div>
          <div class="floating-element element-4"></div>
        </div>
      </div>

      <div class="hero-content">
        <div class="hero-icon">
          <svg viewBox="0 0 24 24" class="main-icon">
            <path
              d="M4.5 16.5c-1.5 1.5-1.5 3.9 0 5.4s3.9 1.5 5.4 0l.8-.8a5.5 5.5 0 0 0 1.6-3.9V14l-2.5-2.5H6.8a5.5 5.5 0 0 0-3.9 1.6l-.8.8z"
            ></path>
            <path d="M12 7.5L10.5 9 9 7.5l1.5-1.5L12 7.5z"></path>
            <path d="M15 3.5L16.5 5 18 3.5 16.5 2 15 3.5z"></path>
            <path d="M9 10.5L7.5 12 6 10.5 7.5 9 9 10.5z"></path>
            <path d="m21 1-1 2 2 1-2 1 1 2-1-2-2 1 2-1-1-2 1 2 2-1-2-1z"></path>
          </svg>
        </div>

        <h1 class="hero-title">
          <span class="title-line">Something Amazing</span>
          <span class="title-line highlighted">Is Coming Soon</span>
        </h1>

        <p class="hero-description">
          We're working hard to bring you an incredible new feature that will
          transform your Markado experience. Stay tuned for something special!
        </p>

        <div class="progress-section">
          <div class="progress-info">
            <span class="progress-label">Development Progress</span>
            <span class="progress-percentage">{{ progressPercentage }}%</span>
          </div>
          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="0"></div>
          </div>
        </div>

        <div *ngIf="showCountdown" class="countdown-section">
          <h3 class="countdown-title">Estimated Launch</h3>
          <div class="countdown-timer">
            <div class="countdown-item">
              <div class="countdown-number">{{ timeRemaining.days }}</div>
              <div class="countdown-label">Days</div>
            </div>
            <div class="countdown-divider">:</div>
            <div class="countdown-item">
              <div class="countdown-number">{{ timeRemaining.hours }}</div>
              <div class="countdown-label">Hours</div>
            </div>
            <div class="countdown-divider">:</div>
            <div class="countdown-item">
              <div class="countdown-number">{{ timeRemaining.minutes }}</div>
              <div class="countdown-label">Minutes</div>
            </div>
            <div class="countdown-divider">:</div>
            <div class="countdown-item">
              <div class="countdown-number">{{ timeRemaining.seconds }}</div>
              <div class="countdown-label">Seconds</div>
            </div>
          </div>
        </div>

        <div *ngIf="!showCountdown && showEstimate" class="estimate-section">
          <div class="estimate-container">
            <div class="estimate-icon">
              <svg viewBox="0 0 24 24" class="estimate-svg">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12,6 12,12 16,14"></polyline>
              </svg>
            </div>
            <h3 class="estimate-title">{{ estimatedTimeframe }}</h3>
            <p class="estimate-description">
              We're working hard to bring this to you as soon as possible!
            </p>
            <div class="pulse-indicator">
              <div class="pulse-dot"></div>
              <div class="pulse-ring"></div>
            </div>
          </div>
        </div>

        <div class="hero-actions">
          <button class="btn btn-secondary" routerLink="/">
            <svg viewBox="0 0 24 24" class="btn-icon">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            Home Page
          </button>
        </div>
      </div>
    </section>

    <section class="features-section">
      <div class="features-container">
        <div class="section-header">
          <h2 class="section-title">What's Coming</h2>
          <p class="section-description">
            Here's a sneak peek at the exciting features we're building for you
          </p>
        </div>

        <div class="features-grid">
          <div
            *ngFor="let feature of features; let i = index"
            class="feature-card"
            [style.animation-delay.ms]="i * 150"
          >
            <div class="feature-icon">
              <svg
                *ngIf="feature.icon === 'rocket'"
                viewBox="0 0 24 24"
                class="feature-svg"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm-4.5 12.5L4 20l1.5-3.5 2 1zm9 0l2-1-1.5 3.5-2-1zm-3.5-2.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                />
              </svg>

              <svg
                *ngIf="feature.icon === 'shield'"
                viewBox="0 0 24 24"
                class="feature-svg"
              >
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7z"
                ></path>
                <path d="m9 12 2 2 4-4"></path>
              </svg>

              <svg
                *ngIf="feature.icon === 'sparkles'"
                viewBox="0 0 24 24"
                class="feature-svg"
              >
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M12 1v6"></path>
                <path d="M12 17v6"></path>
                <path d="M4.22 4.22l4.24 4.24"></path>
                <path d="M15.54 15.54l4.24 4.24"></path>
                <path d="M1 12h6"></path>
                <path d="M17 12h6"></path>
                <path d="M4.22 19.78l4.24-4.24"></path>
                <path d="M15.54 8.46l4.24-4.24"></path>
              </svg>

              <svg
                *ngIf="feature.icon === 'users'"
                viewBox="0 0 24 24"
                class="feature-svg"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </main>

  <app-footer></app-footer>
</div>
